<template>
  <section>
    <div class="row">
      <div class="col-md-12">
        <p>
          Use the following to create/manage views with selected columns for
          customizing the coach listing across all organizations
        </p>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <div class="input-group">
          <span class="input-group-text">view</span>
          <input
            ref="inputAddView"
            class="form-control"
            v-if="isAdd"
            v-model="view"
            placeholder="enter new view name"
            @blur="updateView"
          />
          <select
            v-else
            class="form-select"
            v-model="view"
            @change="selectView"
          >
            <option v-for="(view, idx) of customViews" :key="idx">
              {{ view.name }}
            </option>
          </select>
          <button class="btn btn-link" @click="addView">
            <i class="fas fa-plus"></i>
          </button>
          <button v-if="showDelete" class="btn btn-link" @click="removeView">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="col-md-1"></div>
    </div>
    <div class="row mb-2">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <div class="input-group">
          <span class="input-group-text">add column</span>
          <select v-model="column" class="form-select">
            <option v-for="column of columns" :value="column" :key="column.id">
              {{ column.name }}
            </option>
          </select>
          <button class="btn btn-link" @click="addColumn">
            <i class="fas fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="col-md-1"></div>
    </div>
    <div class="custom-table">
      <z-table
        :value="selectedColumns"
        sortOn="id"
        sortDir="asc"
        :isSingleRowDetail="false"
        :columns="tableColumns"
        class="table table-bordered table-striped"
      >
        <template v-slot:tbody="props">
          <td>{{ props.row.name }}</td>
          <td
            class="custom-column-60"
            @mouseenter="showSpin = props.row.id"
            @mouseleave="showSpin = null"
          >
            <z-stepper
              v-if="showSpin === props.row.id"
              @clickUp="stepperClickedUp(props.row.id)"
              @clickDown="stepperClickedDown(props.row.id)"
            />
          </td>
          <td class="custom-column-60">
            <a href="#" @click="removeColumn(props.row)">remove</a>
          </td>
        </template>
      </z-table>
    </div>
    <div class="row mt-2">
      <div class="col-md-6">
        <button class="btn btn-primary me-2" @click="applyToAll()">
          Apply to all Coaches
        </button>
      </div>
      <div class="col-md-6">
        <div class="custom-buttons">
          <button
            v-if="isHighlight"
            class="btn btn-primary me-2"
            :class="{ 'btn-danger': isHighlight }"
            @click="performSave()"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZStepper from '@/Components/ZElements/Stepper'
import ZTable from '@/Components/ZElements/Table'
import ZSelect from '@/Components/ZElements/Select'
export default {
  name: 'custom-views',
  components: {
    ZStepper,
    ZTable,
    ZSelect,
  },
  data() {
    return {
      showSpin: null,
      sortChanged: false,
      column: null,
      isHighlight: false,
      isAdd: false,
      showDelete: false,
    }
  },
  async mounted() {
    this.isAdd = false
    this.showDelete = false
    this.isHighlight = false
    await this.getCustomViewsConfig({
      classification: 'Configuration',
      name: 'CustomViews',
    })
    this.resetSelectedView()
  },
  computed: {
    ...mapGetters('usercardio', ['columns', 'selectedView', 'customViews']),
    tableColumns() {
      return [
        {
          field: 'name',
          label: 'Name',
          sortable: false,
        },
        {
          field: 'order',
          label: 'sort',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
    view: {
      get() {
        let _data = null
        if (this.selectedView) {
          _data = this.selectedView.name
        }
        console.log('Selected View is', _data)
        return _data
      },
      set(value) {
        console.log('Set Selected View', value)
        this.setSelectedView({ name: value, isAdd: this.isAdd })
      },
    },
    views() {
      let _views = []
      let _cnt = 0
      this.customViews.forEach((view) => {
        _views.push({
          id: _cnt,
          name: view.name,
        })
        _cnt++
      })
      return _views
    },
    selectedColumns() {
      let _columns = []
      if (this.selectedView) {
        _columns = this.selectedView.columns
      }
      console.log('Selected Columns', _columns)
      return _columns
    },
  },
  methods: {
    ...mapActions('usercardio', [
      'resetSelectedView',
      'setCustomColumn',
      'getCustomViewsConfig',
      'setSelectedView',
      'updateCustomView',
      'saveCustomViewsConfig',
      'applyCustomViews',
    ]),
    selectView() {
      this.selectedColumns = []
      this.showDelete = true
      this.isAdd = false
      this.isHighlight = false
      console.log('Selected a View', {
        view: this.view,
      })
    },
    addColumn() {
      if (this.view !== '') {
        if (this.column) {
          let data = {
            name: 'add',
            value: this.column,
            direction: null,
            view: this.view,
          }
          console.log('Adding Column 1', data)
          this.setCustomColumn(data)
          this.isHighlight = true
        } else {
          alert('Please supply a Column Name')
        }
      } else {
        alert('Please supply a View Name')
      }
    },
    removeColumn(row) {
      let data = {
        name: 'remove',
        value: row,
        direction: null,
        view: this.view,
      }
      console.log('Removing Column', data)
      this.setCustomColumn(data)
      this.isHighlight = true
    },
    stepperClickedUp(id) {
      this.sortChanged = true
      this.showSpin = null
      this.setCustomColumn({
        name: 'sort',
        value: id,
        direction: 'up',
        view: this.view,
      })
      this.showSpin = null
      this.isHighlight = true
    },
    stepperClickedDown(id) {
      this.sortChanged = true
      this.showSpin = null
      this.setCustomColumn({
        name: 'sort',
        value: id,
        direction: 'down',
        view: this.view,
      })
      this.showSpin = null
      this.isHighlight = true
    },
    addView() {
      let $this = this
      this.setSelectedView({ name: '' })
      this.isAdd = true
      this.showDelete = false
      this.isHighlight = true
      setTimeout(() => {
        $this.$refs.inputAddView.focus()
      }, 250)
    },
    updateView() {
      let data = {
        action: 'add',
        name: this.view,
      }
      this.updateCustomView(data)
      this.showDelete = true
      this.isHighlight = true
    },
    removeView() {
      let data = {
        action: 'remove',
        name: this.view,
      }
      console.log('Removing View', data)
      this.updateCustomView(data)
      this.isAdd = false
      this.showDelete = false
      this.isHighlight = true
    },
    async performSave() {
      let data = {
        name: 'CustomViews',
        classification: 'Configuration',
        textvalue: JSON.stringify(this.customViews),
      }
      console.log('Saving', data)
      await this.saveCustomViewsConfig(data)
      await this.getCustomViewsConfig({
        classification: 'Configuration',
        name: 'CustomViews',
      })
      this.resetSelectedView()
      this.column = null
      this.isAdd = false
      this.showDelete = false
      this.isHighlight = false
    },
    async applyToAll() {
      console.log('Apply to All')
      await this.applyCustomViews()
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-buttons {
  position: relative;
  float: right;
}
.custom-table {
  width: auto;
  height: 255px;
  max-height: 255px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
